export default {
  sections: [
    {
      title: 'LOANS',
      cols: '2',
      items: [
        {
          text: 'FIX AND FLIP LOANS',
          link: 'https://www.anchorloans.com/loans/fix-and-flip-loans/',
        },
        {
          text: 'NEW CONSTRUCTION LOANS',
          link: 'https://www.anchorloans.com/loans/new-construction-loans/',
        },
        {
          text: 'BRIDGE LOANS',
          link: 'https://www.anchorloans.com/loans/bridge-loans/',
        },
        {
          text: 'INVEST',
          link: 'https://www.anchorloans.com/invest',
        },
      ],
    },
    {
      title: 'LEARN',
      cols: '2',
      items: [
        {
          text: 'BROKERS',
          link: 'https://www.anchorloans.com/broker',
        },
        {
          text: 'FAQS',
          link: 'https://www.anchorloans.com/faq',
        },
        {
          text: 'Private Direct Lender',
          link: 'https://www.anchorloans.com/private-direct-lender',
        },
        {
          text: 'Hard Money Lender',
          link: 'https://www.anchorloans.com/hard-money-lender',
        },
        {
          text: 'Non-Traditional Lending',
          link: 'https://www.anchorloans.com/non-traditional-lending',
        },
      ],
    },
    {
      title: 'COMPANY',
      cols: '4',
      items: [
        {
          text: 'ABOUT',
          link: 'https://www.anchorloans.com/about',
        },
        {
          text: 'ANCHOR HOMES',
          link: 'https://www.anchorloans.com/anchor-homes',
        },
        {
          text: 'BLOG',
          link: 'https://www.anchorloans.com/blog/',
        },
        {
          text: 'PRESS',
          link: 'https://www.anchorloans.com/category/press/',
        },
        {
          text: 'CONTACT US',
          link: 'https://www.anchorloans.com/contact',
        },
        {
          text: 'LEGAL',
          link: 'https://www.anchorloans.com/legal',
        },
        {
          text: 'CAREERS',
          link: 'https://www.anchorloans.com/careers',
        },
        {
          text: 'BRAND GUIDELINES',
          link: 'https://www.anchorloans.com/brand-guide',
        },
      ],
    },
  ],
  social: [
    {
      class: 'btn-facebook',
      link: 'https://www.facebook.com/AnchorLoansLP/',
      icon: 'facebook',
      title: 'Visit our Facebook page.',
    },
    {
      class: 'btn-linkedin',
      link: 'https://www.linkedin.com/company/anchor-loans',
      icon: 'linkedin',
      title: 'Visit our Linkedin page.',
    },
    {
      class: 'btn-twitter',
      link: 'https://twitter.com/AnchorLoans',
      icon: 'twitter',
      title: 'Visit our Twitter page.',
    },
    {
      class: 'btn-instagram',
      link: 'https://www.instagram.com/explore/tags/anchorloans/?hl=en',
      icon: 'instagram',
      title: 'Visit our Instagram page.',
    },
  ],
  inc5000: {
    title: 'Inc. 5000',
    alt: 'Anchor Loans was named among the Inc. 5000 fastest growing private companies.',
  },
};



// WEBPACK FOOTER //
// ./src/components/base/footer/resources.js